export default __webpack_public_path__ + "static/reading-de@2x-032fc2da4af05f133b09464b802abb28.png";